import { useNavigate } from "react-router-dom";
import { useTheme } from "next-themes";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import logoDarkMode from "@/assets/straiv-logo-light.png";
import logoLightMode from "@/assets/straiv-logo-dark-new.png";
import { SAFE_AREA } from "@/utils/safeArea";

export const Header = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const isDark = resolvedTheme === "dark";

  useEffect(() => {
    setMounted(true);
  }, []);

  // Avoid theme flash: use light logo until mounted to prevent placeholder/broken image
  const logoSrc = mounted ? (isDark ? logoDarkMode : logoLightMode) : logoLightMode;

  return (
    <header
      className="fixed left-0 right-0 z-50 backdrop-blur-xl"
      style={{
        top: 0,
        height: `calc(${SAFE_AREA.top} + 56px)`,
        paddingTop: SAFE_AREA.top,
        paddingLeft: SAFE_AREA.left,
        paddingRight: SAFE_AREA.right,
        backgroundColor: isDark ? 'rgba(10, 10, 14, 0.6)' : 'var(--nav-bg)',
        borderBottom: isDark ? '1px solid rgba(255,255,255,0.12)' : '1px solid var(--nav-border)',
        boxShadow: isDark 
          ? 'inset 0 -1px 0 0 rgba(255,255,255,0.05)' 
          : '0 4px 24px hsla(220, 20%, 50%, 0.08)',
      }}
    >
      <div className="flex items-center h-full px-4 relative overflow-hidden" style={{ height: '56px' }}>
        <img
          src={logoSrc}
          alt={t('components.header.logoAlt')}
          className="h-20 w-auto object-contain object-left cursor-pointer min-w-[80px]"
          loading="eager"
          fetchPriority="high"
          onClick={() => navigate("/dashboard")}
        />
      </div>
    </header>
  );
};
